import { SuperInput } from "@components:SuperInput/SuperInput";
import { Toggle } from "@components:Toggle";
import { useDebounce } from "@hooks:useDebounce";
import { Box, InputAdornment } from "@mui/material";
import Button from "@mui/material/Button";
import { Header } from "@pages:settings/Header";
import {
  useUiPreferencesActions,
  useUiPreferencesData,
} from "@stores:settings/ui-preferences";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IoMdSearch } from "react-icons/io";
import { MdClear, MdTune } from "react-icons/md";

import { UiPreferenceModal } from "./UiPreferenceModal";
import { UiPreferencesTable } from "./UiPreferencesTable";

export const UiPreferences = () => {
  const { t } = useTranslation();
  const { searchKeyword, state } = useUiPreferencesData();
  const { setSearchKeyword, setState, unMount } = useUiPreferencesActions();
  const [isOpenModalToCreate, setIsOpenModalToCreate] = useState(false);
  const [searchKey, setSearchKey] = useState("");

  const states = [
    {
      label: t("common.active"),
      value: "active",
    },
    {
      label: t("common.inactive"),
      value: "inactive",
    },
  ];

  useEffect(() => {
    return () => {
      unMount();
    };
  }, [unMount]);

  const onChange = () => {
    setSearchKeyword(searchKey);
  };

  const debouncedOnChange = useDebounce(onChange);

  return (
    <Box
      className="Settings__UiPreferences"
      sx={{
        width: "100%",
        height: "100%",
        overflowY: "hidden",
        overflowX: "auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Header
        leftSide={
          <Toggle state={state} allState={states} setState={setState} />
        }
        rightSide={
          <Box
            sx={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <Button
              variant="outlined"
              startIcon={<MdTune />}
              onClick={() => {
                setIsOpenModalToCreate(true);
              }}
            >
              {t("preferences.uiPreferences.add")}
            </Button>
            <SuperInput.TextField
              autoHeight={false}
              placeholder={t("preferences.uiPreferences.searchPlaceholder")}
              value={searchKey}
              onChange={(e) => {
                debouncedOnChange();
                setSearchKey(e.target.value);
              }}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{
                        backgroundColor: "transparent",
                      }}
                    >
                      <IoMdSearch size={20} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={{
                        cursor: "pointer",
                        visibility: searchKeyword ? "visible" : "hidden",
                      }}
                      onClick={() => {
                        debouncedOnChange();
                        setSearchKey("");
                      }}
                    >
                      <MdClear size={20} />
                    </InputAdornment>
                  ),
                },
              }}
            />
          </Box>
        }
      />
      <Box
        sx={{
          flex: 1,
          minHeight: "0",
          pt: "2.5rem",
          px: "2.5rem",
        }}
      >
        <UiPreferencesTable />
      </Box>
      {isOpenModalToCreate && (
        <UiPreferenceModal
          isOpen={isOpenModalToCreate}
          onClose={() => setIsOpenModalToCreate(false)}
        />
      )}
    </Box>
  );
};
